import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const [email, setEmail] = useState('');
  
  // Obfuscated email - decoded on client side
  useEffect(() => {
    const parts = ['contact', 'dominiquefiore', 'com'];
    setEmail(`${parts[0]}@${parts[1]}.${parts[2]}`);
  }, []);
  
  return (
    <footer className="fixed bottom-0 left-0 right-0 bg-black text-white py-4 border-t border-white border-opacity-10 z-50">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-center md:text-left">
            <p className="text-sm font-light tracking-wide font-oswald">&copy; {new Date().getFullYear()} Dominique Fiore</p>
          </div>
          
          <div className="flex items-center gap-6">
            <a 
              href="https://www.imdb.com/fr/name/nm2554027/?ref_=fn_t_1" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-sm text-gray-400 hover:text-white transition-colors font-oswald tracking-wider"
              data-testid="footer-imdb-link"
            >
              IMDB
            </a>
            <a 
              href="https://www.linkedin.com/in/dominique-fiore-61b312b/?originalSubdomain=fr" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-sm text-gray-400 hover:text-white transition-colors font-oswald tracking-wider"
              data-testid="footer-linkedin-link"
            >
              LINKEDIN
            </a>
            <Link 
              to="/contact" 
              className="text-sm text-gray-400 hover:text-white transition-colors font-oswald tracking-wider"
              data-testid="footer-contact-link"
            >
              CONTACT
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
